import '.e7{padding:16px;}.ssr-plugin'
import '.v{border-radius:16px;}.ssr-plugin'
import '.gs{max-width:404px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.gt{overflow-wrap:anywhere;}.ssr-plugin'
import '.d7{word-break:break-word;}.ssr-plugin'
import '.d0{min-width:0px;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'

type NoteProps = {
  leadIcon?: React.ReactNode
  color?: 'orange' | 'red'
  children: React.ReactNode
  style?: Style
}

export const Note = ({ leadIcon, color, children, style }: NoteProps) => {
  return (
    <styled.div className="blur e7 v gs ai e cc"
      style={{
        backgroundColor:
          color === 'red'
            ? transparentColor(colors.red, 0.15)
            : transparentColor(colors.orange, 0.15),
        border:
          color === 'red'
            ? `1px solid ${transparentColor(colors.red, 0.15)}`
            : `1px solid ${transparentColor(colors.orange, 0.15)}`,
        color: color === 'red' ? colors.red : colors.orange,
        ...style,
      }}
    >
      {leadIcon ? <span>{leadIcon}</span> : null}
      <p className="gt d7 d0"
      >
        {children}
      </p>
    </styled.div>
  )
}
